export const PLATFORMS = ["PS5", "Xbox", "Steam"];

export const GAME_MODES = ["REC", "Park", "The Stage", "Theater", "Pro-Am", "MyTEAM", "Play Now Online"];

export const CHEAT_TYPES = [
  "Cronus / XIM",
  "Auto-Green Macro",
  "Playing with Cheaters",
  "Account Sharing / Selling",
  "Stat Boosting",
  "Lag Switching",
  "Glitch / Bug Exploit",
  "Modded Controller",
  "Rage Quit / No-Loss Glitch",
  "Racism / Hate Speech",
  "Other",
];

export const GLITCH_CHEAT_TYPE = "Glitch / Bug Exploit";

export const REACTIONS = ["🔥", "🤬", "🧢", "💀"];

// Paste your Discord invite link here (e.g. https://discord.gg/xxxxxx)
export const DISCORD_INVITE = "https://discord.gg/A9AubPnPQ";

export const STATUS_META = {
  pending: { label: "Under Review", color: "#FFB800", bg: "rgba(255,184,0,0.12)", dot: "#FFB800" },
  suspect: { label: "Unverified · Community", color: "#F97316", bg: "rgba(249,115,22,0.12)", dot: "#F97316" },
  disputed: { label: "Disputed", color: "#EF4444", bg: "rgba(239,68,68,0.14)", dot: "#EF4444" },
  approved: { label: "Vetted by Mods", color: "#00F0FF", bg: "rgba(0,240,255,0.12)", dot: "#00F0FF" },
  sent_to_dev: { label: "Sent to 2K Devs", color: "#00FF87", bg: "rgba(0,255,135,0.12)", dot: "#00FF87" },
  banned: { label: "Confirmed Cheater", color: "#FF2A55", bg: "rgba(255,42,85,0.15)", dot: "#FF2A55" },
  confirmed_cheater: { label: "Confirmed Cheater", color: "#FF2A55", bg: "rgba(255,42,85,0.15)", dot: "#FF2A55" },
  rejected: { label: "Rejected", color: "#64748B", bg: "rgba(100,116,139,0.12)", dot: "#64748B" },
};

export const PLATFORM_COLORS = {
  PC: "#00F0FF",
  PS5: "#0070D1",
  Xbox: "#107C10",
  Steam: "#66C0F4",
};

// Trusted, permanent, publicly-viewable video hosts accepted as proof.
export const ALLOWED_VIDEO_HOSTS = [
  "youtube.com", "youtu.be", "streamable.com", "twitch.tv",
  "medal.tv", "imgur.com", "twitter.com", "x.com", "drive.google.com",
];

export const videoHostAllowed = (url) => {
  const u = (url || "").trim();
  if (u.startsWith("/api/files/") || u.includes("/api/files/")) return true;
  try {
    let netloc = new URL(u).hostname.toLowerCase();
    if (netloc.startsWith("www.")) netloc = netloc.slice(4);
    return ALLOWED_VIDEO_HOSTS.some((h) => netloc === h || netloc.endsWith("." + h));
  } catch {
    return false;
  }
};


// Pull a thumbnail image from a video URL (YouTube supported) for use as a card cover.
export const videoThumbnail = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return m ? `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg` : null;
};

// Parse "1:05" / "0:34" / "90" into total seconds. Returns null if unparseable.
export const parseTimestamp = (ts) => {
  if (!ts) return null;
  const clean = String(ts).trim();
  if (/^\d+$/.test(clean)) return parseInt(clean, 10);
  const parts = clean.split(":").map((p) => p.trim());
  if (parts.some((p) => !/^\d+$/.test(p))) return null;
  return parts.reduce((acc, p) => acc * 60 + parseInt(p, 10), 0);
};

// One-tap AI Clip Scanner presets. Empty = log every shot; a value highlights matching shots.
export const SCAN_PRESETS = [
  "All jump shots",
  "Perfect greens only",
  "Contested greens",
  "Deep / logo-range threes",
  "Half court or beyond",
  "Missed open shots",
];


// Build a best-effort "jump to timestamp" URL. YouTube/Twitch support deep-linking.
export const videoJumpUrl = (url, ts) => {
  const secs = parseTimestamp(ts);
  if (!url || secs == null) return url;
  if (/youtube\.com|youtu\.be/.test(url)) {
    return url + (url.includes("?") ? "&" : "?") + `t=${secs}s`;
  }
  if (/twitch\.tv/.test(url)) {
    const h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
    return url + (url.includes("?") ? "&" : "?") + `t=${h}h${m}m${s}s`;
  }
  return url;
};


// Certified Hunter ranks, based on confirmed busts. Mirror of backend hunter_tier().
export const hunterTier = (busts) => {
  const n = Number(busts) || 0;
  if (n >= 25) return { label: "Legendary Hunter", short: "Legendary", color: "#FFB800" };
  if (n >= 10) return { label: "Elite Hunter", short: "Elite", color: "#A855F7" };
  if (n >= 3) return { label: "Veteran Hunter", short: "Veteran", color: "#00F0FF" };
  if (n >= 1) return { label: "Rookie Hunter", short: "Rookie", color: "#00FF87" };
  return null;
};
